import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CardActions, CardContent, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { Selectors } from '../../selectors';
import { EULA_FILE_PATH } from '../../constants';
import { PDFRender } from '../../components/PDFRender/PDFRender';

type Props = {
    agree: boolean;
    initialEULA?: string;
    onEulaAccept?: Function;
    scrolled: boolean;
    onEulaScrolled?: Function;
    changeNextEnabled?: Function;
    changeNextLabel?: Function;
    onLoad?: Function;
};

export const EULA: React.FC<Props> = (props: Props) => {
    const { t } = useLanguageLocale();
    const registration = useSelector(Selectors.Registration.registration);

    const eulaAgree = props.agree;
    const eulaScrolled = props.scrolled;

    const { initialEULA, onEulaAccept, onEulaScrolled, onLoad, changeNextEnabled, changeNextLabel } = props;

    if (changeNextEnabled) {
        changeNextEnabled(eulaAgree);
    }
    if (changeNextLabel) {
        changeNextLabel(t('ACTIONS.NEXT'));
    }

    const eulaContent = React.createRef<HTMLDivElement>();
    useEffect(() => {
        if (!registration.eula && !registration.eulaLoading && onLoad) {
            onLoad();
        }
    });

    const handleScroll = (): void => {
        if (!registration.eula) {
            return;
        }
        const element = eulaContent.current;
        if (!element) {
            return;
        }
        if (element.scrollHeight - element.scrollTop <= element.clientHeight + 20) {
            if (onEulaScrolled) {
                onEulaScrolled();
            }
        }
    };

    useEffect(() => {
        handleScroll();
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (onEulaAccept) {
            onEulaAccept(e.target.checked);
        }
        if (changeNextEnabled) {
            changeNextEnabled(e.target.checked);
        }
    };

    return (
        <>
            <CardContent
                style={{ flex: '1 1 0px', overflow: 'auto' }}
                onScroll={registration.eula ? handleScroll : undefined}
                ref={eulaContent}
                data-testid={'eula-content'}
            >
                {process.env.NODE_ENV !== 'test' ? (
                    <PDFRender key={'pdf'} file={EULA_FILE_PATH} pageCount={14} width={400} />
                ) : (
                    <Typography>{registration.eula || initialEULA || t('REGISTRATION.EULA.LOADING')}</Typography>
                )}
            </CardContent>

            <CardActions style={{ padding: '8px 0' }}>
                <FormControlLabel
                    style={{ marginLeft: 0 }}
                    control={
                        <Checkbox
                            checked={eulaAgree}
                            disabled={!eulaScrolled}
                            onChange={handleChange}
                            data-testid="eula-checkbox"
                        />
                    }
                    label={t('REGISTRATION.EULA.AGREE_TERMS')}
                />
            </CardActions>
        </>
    );
};
